
import { renderDifferentTableCell } from "@/utils/common";

// 表格列配置
export const getCompleteCxLxKlsParamsColumns = (allData: any, isKlsV3: boolean) => {
  const list =  [
    
    // 基础版本信息
    {
      title: '版本号',
      dataIndex: 'version',
      width: 80,
    },

    // 车辆参数
    {
      title: '车辆参数-车辆类型/厂家',
      dataIndex: 'vehType',
      width: 120,
    },
    {
      title: '车辆参数-长度',
      dataIndex: 'vehLength',
      width: 80,
    },
    {
      title: '车辆参数-宽度',
      dataIndex: 'vehWidth',
      width: 80,
    },
    {
      title: '车辆参数-宽度(带后视镜)',
      dataIndex: 'vehWidth1',
      width: 120,
    },
    {
      title: '车辆参数-高度',
      dataIndex: 'vehHeight',
      width: 80,
    },
    {
      title: '车辆参数-车后轴到车尾距离',
      dataIndex: 'vehRearToWheelLr',
      width: 140,
    },
    {
      title: '车辆参数-轴距',
      dataIndex: 'vehWheelBaseLb',
      width: 80,
    },
    {
      title: '车辆参数-车前轴到车头距离',
      dataIndex: 'vehFrontToWheelLf',
      width: 140,
    },
    {
      title: '车辆参数-制动器最大制动力度',
      dataIndex: 'vehMaxBrakeForce',
      width: 140,
    },
    {
      title: '车辆参数-满载总质量',
      dataIndex: 'vehMaxFullLoadWeight',
      width: 100,
    },
    {
      title: '车辆参数-空载整备质量',
      dataIndex: 'vehUnloadenWeight',
      width: 120,
    },
    {
      title: '车辆参数-方向盘与前轮传动比',
      dataIndex: 'vehAngleRatioOfSteeringSys',
      width: 160,
    },
    {
      title: '车辆参数-判断车辆是否静止的速度阈值',
      dataIndex: 'vehStandstillVelocityThreshold',
      width: 200,
    },
    {
      title: '车辆参数-整车最大驱动力',
      dataIndex: 'vehMaxAccForce',
      width: 120,
    },
    {
      title: '车辆参数-AEB最大制动力度',
      dataIndex: 'vehMaxAebBrakeForce',
      width: 140,
    },
    {
      title: '车辆参数-车速获取方式',
      dataIndex: 'vehSpeedAcquisitionMethod',
      width: 120,
    },
    {
      title: '车辆参数-刹车灯获取方式',
      dataIndex: 'vehBrkLtAcquisitionMethod',
      width: 140,
    },
    {
      title: '车辆参数-转向灯获取方式',
      dataIndex: 'vehTurnLightAcquisitionMethod',
      width: 140,
    },
    {
      title: '车辆参数-倒挡信号获取方式',
      dataIndex: 'vehGearSignalAcquisitionMethod',
      width: 160,
    },

    // 相机参数
    {
      title: '相机参数-距离车辆中心线距离',
      dataIndex: 'camInstallX',
      width: 140,
    },
    {
      title: '相机参数-距离后轴距离',
      dataIndex: 'camInstallY',
      width: 120,
    },
    {
      title: '相机参数-安装高度',
      dataIndex: 'camInstallZ',
      width: 100,
    },
    {
      title: '相机参数-俯仰角',
      dataIndex: 'camInstallPitchAngle',
      width: 80,
    },
    {
      title: '相机参数-横滚角',
      dataIndex: 'camInstallRollAngle',
      width: 80,
    },
    {
      title: '相机参数-航向角',
      dataIndex: 'camInstallYawAngle',
      width: 80,
    },
    {
      title: '相机参数-相机焦距',
      dataIndex: 'camFocus',
      width: 100,
    },
    {
      title: '相机参数-X方向（横向）像素尺寸',
      dataIndex: 'camPixelSizeX',
      width: 160,
    },
    {
      title: '相机参数-Y方向（横向）像素尺寸',
      dataIndex: 'camPixelSizeY',
      width: 160,
    },
    {
      title: '相机参数-图像横向像素个数',
      dataIndex: 'camImgW',
      width: 140,
    },
    {
      title: '相机参数-图像纵向像素个数',
      dataIndex: 'camImgH',
      width: 140,
    },
    {
      title: '相机参数-帧率',
      dataIndex: 'camIfs',
      width: 80,
    },
    {
      title: '相机参数-最大输出有效目标个数',
      dataIndex: 'camMaxObsCnt',
      width: 160,
    },
    {
      title: '相机参数-最大输出车道线数量',
      dataIndex: 'camMaxRoadLineCnt',
      width: 160,
    },

    // 雷达参数
    {
      title: '雷达参数-车辆坐标系横轴',
      dataIndex: 'radarX',
      width: 120,
    },
    {
      title: '雷达参数-车辆坐标系纵轴',
      dataIndex: 'radarY',
      width: 120,
    },
    {
      title: '雷达参数-车辆坐标系竖轴',
      dataIndex: 'radarZ',
      width: 120,
    },
    {
      title: '雷达参数-雷达横向视场角',
      dataIndex: 'radarFov',
      width: 120,
    },
    {
      title: '雷达参数-最远探测距离',
      dataIndex: 'radarMaxLength',
      width: 120,
    },
    {
      title: '雷达参数-帧率',
      dataIndex: 'radarIfs',
      width: 80,
    },
    {
      title: '雷达参数-最大输出目标数量',
      dataIndex: 'radarMaxObsCnt',
      width: 140,
    },

    // AEB功能参数
    {
      title: 'AEB功能参数-主版本号',
      dataIndex: 'aebVersionMajor',
      width: 100,
    },
    {
      title: 'AEB功能参数-次版本号',
      dataIndex: 'aebVersionMinor',
      width: 100,
    },
    {
      title: 'AEB功能参数-修订号',
      dataIndex: 'aebVersionPatch',
      width: 80,
    },
    {
      title: 'AEB功能参数-输出减速度比例系数',
      dataIndex: 'aebDecFactor',
      width: 160,
    },
    {
      title: 'AEB功能参数-最大输出减速度',
      dataIndex: 'aebLimitDec',
      width: 140,
    },
    {
      title: 'AEB功能参数-目标减速度',
      dataIndex: 'aebTargetDec',
      width: 120,
    },
    {
      title: 'AEB功能参数-制动系统延迟时间',
      dataIndex: 'aebBrakeDelayTime',
      width: 140,
    },
    {
      title: 'AEB功能参数-安全距离',
      dataIndex: 'aebSafeDistance',
      width: 100,
    },
    {
      title: 'AEB功能参数-预警冷却时间',
      dataIndex: 'aebCoolingTime',
      width: 120,
    },
    {
      title: 'AEB功能参数-刹车冷却时间',
      dataIndex: 'aebBrkCoolingTime',
      width: 120,
    },
    {
      title: 'AEB功能参数-一级预警时间',
      dataIndex: 'aebWarnTime1st',
      width: 120,
    },
    {
      title: 'AEB功能参数-二级预警时间',
      dataIndex: 'aebWarnTime2nd',
      width: 120,
    },
    {
      title: 'AEB功能参数-强制一级预警时间',
      dataIndex: 'aebForceWarnTime1st',
      width: 140,
    },
    {
      title: 'AEB功能参数-强制二级预警时间',
      dataIndex: 'aebForceWarnTime2nd',
      width: 140,
    },
    {
      title: 'AEB功能参数-【功能抑制】FCW预警TTC阈值',
      dataIndex: 'aebMaxWarnTtcLimit',
      width: 200,
    },
    {
      title: 'AEB功能参数-【功能抑制】AEB预警制动TTC阈值',
      dataIndex: 'aebMaxEmergencyBrakeTtcLimit',
      width: 220,
    },
    {
      title: 'AEB功能参数-最小起效车速',
      dataIndex: 'aebMinEnableSpeed',
      width: 120,
    },
    {
      title: 'AEB功能参数-最大起效车速',
      dataIndex: 'aebMaxEnableSpeed',
      width: 120,
    },
    {
      title: 'AEB功能参数-最小失效车速',
      dataIndex: 'aebMinDisableSpeed',
      width: 120,
    },
    {
      title: 'AEB功能参数-最大失效车速',
      dataIndex: 'aebMaxDisableSpeed',
      width: 120,
    },
    {
      title: 'AEB功能参数-【功能抑制】横向加速度阈值',
      dataIndex: 'aebMaxLatAbsAcceLimit',
      width: 180,
    },
    {
      title: 'AEB功能参数-【功能抑制】方向盘转角速率阈值',
      dataIndex: 'aebSteeringWheelAngularVLimit',
      width: 200,
    },
    {
      title: 'AEB功能参数-【功能抑制】方向盘转角阈值',
      dataIndex: 'aebSteeringWheelAngularLimit',
      width: 180,
    },
    {
      title: 'AEB功能参数-强制预警功能开关',
      dataIndex: 'aebForceWarnSwitch',
      width: 140,
    },
    {
      title: 'AEB功能参数-预警期间提前减速功能开关',
      dataIndex: 'aebBrakeWhenWarningSwitch',
      width: 180,
    },
    {
      title: 'AEB功能参数-动态减速度功能开关',
      dataIndex: 'aebDynamicDecSwitch',
      width: 140,
    },
    {
      title: 'AEB功能参数-司机制动，对AEB功能进行冷却功能开关',
      dataIndex: 'aebCdSwitch',
      width: 220,
    },
    {
      title: 'AEB功能参数-模式',
      dataIndex: 'aebMode',
      width: 80,
    },

    // FCW功能参数
    {
      title: 'FCW功能参数-主版本号',
      dataIndex: 'fcwVersionMajor',
      width: 100,
    },
    {
      title: 'FCW功能参数-次版本号',
      dataIndex: 'fcwVersionMinor',
      width: 100,
    },
    {
      title: 'FCW功能参数-修订号',
      dataIndex: 'fcwVersionPatch',
      width: 80,
    },
    {
      title: 'FCW功能参数-目标减速度',
      dataIndex: 'fcwTargetDec',
      width: 120,
    },
    {
      title: 'FCW功能参数-制动系统延迟补偿',
      dataIndex: 'fcwBreakDelayTime',
      width: 140,
    },
    {
      title: 'FCW功能参数-安全距离',
      dataIndex: 'fcwSafeDistance',
      width: 100,
    },
    {
      title: 'FCW功能参数-冷却时间',
      dataIndex: 'fcwCoolingTime',
      width: 100,
    },
    {
      title: 'FCW功能参数-一级预警提前量',
      dataIndex: 'fcwWarnTime1st',
      width: 140,
    },
    {
      title: 'FCW功能参数-二级预警提前量',
      dataIndex: 'fcwWarnTime2nd',
      width: 140,
    },
    {
      title: 'FCW功能参数-强制预警提前量：一级预警',
      dataIndex: 'fcwForceWarnTime1st',
      width: 180,
    },
    {
      title: 'FCW功能参数-强制预警提前量：二级预警',
      dataIndex: 'fcwForceWarnTime2nd',
      width: 180,
    },
    {
      title: 'FCW功能参数-最大预警TTC',
      dataIndex: 'fcwMaxWarnTtcLimit',
      width: 120,
    },
    {
      title: 'FCW功能参数-最小起效车速',
      dataIndex: 'fcwMinEnableSpeed',
      width: 120,
    },
    {
      title: 'FCW功能参数-最大起效车速',
      dataIndex: 'fcwMaxEnableSpeed',
      width: 120,
    },
    {
      title: 'FCW功能参数-最小失效车速',
      dataIndex: 'fcwMinDisableSpeed',
      width: 120,
    },
    {
      title: 'FCW功能参数-最大失效车速',
      dataIndex: 'fcwMaxDisableSpeed',
      width: 120,
    },
    {
      title: 'FCW功能参数-最大横向加速度阈值',
      dataIndex: 'fcwMaxLatAbsAcceLimit',
      width: 160,
    },
    {
      title: 'FCW功能参数-方向盘转角速率阈值',
      dataIndex: 'fcwSteeringWheelAngularVLimit',
      width: 160,
    },
    {
      title: 'FCW功能参数-方向盘转角阈值',
      dataIndex: 'fcwSteeringWheelAngularLimit',
      width: 140,
    },
    {
      title: 'FCW功能参数-强制预警功能开关',
      dataIndex: 'fcwForceWarnSwitch',
      width: 140,
    },

    // HMW功能参数
    {
      title: 'HMW功能参数-主版本号',
      dataIndex: 'hmwVersionMajor',
      width: 100,
    },
    {
      title: 'HMW功能参数-次版本号',
      dataIndex: 'hmwVersionMinor',
      width: 100,
    },
    {
      title: 'HMW功能参数-修订号',
      dataIndex: 'hmwVersionPatch',
      width: 80,
    },
    {
      title: 'HMW功能参数-基础报警时间阈值（一级预警）',
      dataIndex: 'hmwWarnThreshold',
      width: 200,
    },
    {
      title: 'HMW功能参数-报警延迟退出阈值偏置',
      dataIndex: 'hmwWarnDelayExitThreshold',
      width: 180,
    },
    {
      title: 'HMW功能参数-制动时间阈值（二级预警）',
      dataIndex: 'hmwBrkThreshold',
      width: 180,
    },
    {
      title: 'HMW功能参数-制动延迟退出阈值偏置',
      dataIndex: 'hmwBrkDelayExitThreshold',
      width: 180,
    },
    {
      title: 'HMW功能参数-制动体感',
      dataIndex: 'hmwBrkSomatosensory',
      width: 100,
    },
    {
      title: 'HMW功能参数-最大横向加速度阈值',
      dataIndex: 'hmwMaxLatAbsAcceLimit',
      width: 160,
    },
    {
      title: 'HMW功能参数-预警冷却时间长度',
      dataIndex: 'hmwCoolingTime',
      width: 140,
    },
    {
      title: 'HMW功能参数-制动冷却时间长度',
      dataIndex: 'hmwBrkCoolingTime',
      width: 140,
    },
    {
      title: 'HMW功能参数-最小起效车速',
      dataIndex: 'hmwMinEnableSpeed',
      width: 120,
    },
    {
      title: 'HMW功能参数-最大起效车速',
      dataIndex: 'hmwMaxEnableSpeed',
      width: 120,
    },
    {
      title: 'HMW功能参数-最小失效车速',
      dataIndex: 'hmwMinDisableSpeed',
      width: 120,
    },
    {
      title: 'HMW功能参数-最大失效车速',
      dataIndex: 'hmwMaxDisableSpeed',
      width: 120,
    },
    {
      title: 'HMW功能参数-【功能抑制】横向加速度阈值',
      dataIndex: 'hmwSteeringWheelAngularALimit',
      width: 180,
    },
    {
      title: 'HMW功能参数-【功能抑制】方向盘转角速率阈值',
      dataIndex: 'hmwSteeringWheelAngularVLimit',
      width: 200,
    },
    {
      title: 'HMW功能参数-【功能抑制】方向盘转角阈值',
      dataIndex: 'hmwSteeringWheelAngularLimit',
      width: 180,
    },
    {
      title: 'HMW功能参数-动态阈值减速度參考值',
      dataIndex: 'hmwDynamicDec',
      width: 160,
    },
    {
      title: 'HMW功能参数-收刹车功能参数',
      dataIndex: 'hmwBrk',
      width: 120,
    },
    {
      title: 'HMW功能参数-制动时机模式',
      dataIndex: 'hmwBrkTimeMode',
      width: 120,
    },
    {
      title: 'HMW功能参数-收刹车功能配置',
      dataIndex: 'hmwBrkCfg',
      width: 140,
    },
    {
      title: 'HMW功能参数-司机制动对HMW功能进行冷却开关',
      dataIndex: 'hmwCdSwitch',
      width: 220,
    },
    {
      title: 'HMW功能参数-模式',
      dataIndex: 'hmwMode',
      width: 80,
    },

    // LDW功能参数
    {
      title: 'LDW功能参数-主版本号',
      dataIndex: 'ldwVersionMajor',
      width: 100,
    },
    {
      title: 'LDW功能参数-次版本号',
      dataIndex: 'ldwVersionMinor',
      width: 100,
    },
    {
      title: 'LDW功能参数-修订号',
      dataIndex: 'ldwVersionPatch',
      width: 80,
    },
    {
      title: 'LDW功能参数-横向加速度抑制阈值',
      dataIndex: 'ldwFAcclerationThresholdValueLat',
      width: 180,
    },
    {
      title: 'LDW功能参数-纵向加速度抑制阈值',
      dataIndex: 'ldwFAcclerationThresholdValueLon',
      width: 180,
    },
    {
      title: 'LDW功能参数-司机主动踩刹车抑制阈值开始',
      dataIndex: 'ldwFDriverBrakeInhibitoryTimeBegin',
      width: 200,
    },
    {
      title: 'LDW功能参数-司机主动踩刹车抑制阈值结束',
      dataIndex: 'ldwFDriverBrakeInhibitoryTimeEnd',
      width: 200,
    },
    {
      title: 'LDW功能参数-LDW使能速度',
      dataIndex: 'ldwFLdwEnableSp',
      width: 120,
    },
    {
      title: 'LDW功能参数-LDW抑制条件方向盘转角速率',
      dataIndex: 'ldwFSteeringWheelAngularVThresholdValue',
      width: 220,
    },
    {
      title: 'LDW功能参数-双闪开启抑制时长',
      dataIndex: 'ldwU8HazardLampInhibitoryTimeBegin',
      width: 160,
    },
    {
      title: 'LDW功能参数-双闪关闭抑制时长',
      dataIndex: 'ldwU8HazardLampInhibitoryTimeEnd',
      width: 160,
    },
    {
      title: 'LDW功能参数-同侧转向灯开启抑制时长',
      dataIndex: 'ldwU8IpsilateralTurnSignalInhibitoryTimeBegin',
      width: 200,
    },
    {
      title: 'LDW功能参数-同侧转向灯关闭抑制时长',
      dataIndex: 'ldwU8IpsilateralTurnSignalInhibitoryTimeEnd',
      width: 200,
    },
    {
      title: 'LDW功能参数-上次LDW报警结束抑制时长',
      dataIndex: 'ldwU8LastStatusIntervalTime',
      width: 180,
    },
    {
      title: 'LDW功能参数-最长报警时长',
      dataIndex: 'ldwU8MaxWarningTime',
      width: 120,
    },
    {
      title: 'LDW功能参数-降至转角速率以下抑制时长',
      dataIndex: 'ldwU8SwAngularInhibitoryTimeLower',
      width: 200,
    },
    {
      title: 'LDW功能参数-超过转角速率抑制时长',
      dataIndex: 'ldwU8SwAngularInhibitoryTimeUpper',
      width: 180,
    },

    // BSD功能参数
    {
      title: 'BSD功能参数-主版本号',
      dataIndex: 'bsdVersionMajor',
      width: 100,
    },
    {
      title: 'BSD功能参数-次版本号',
      dataIndex: 'bsdVersionMinor',
      width: 100,
    },
    {
      title: 'BSD功能参数-修订号',
      dataIndex: 'bsdVersionPatch',
      width: 80,
    },

    // RVC功能参数
    {
      title: 'RVC功能参数-主版本号',
      dataIndex: 'rvcVersionMajor',
      width: 100,
    },
    {
      title: 'RVC功能参数-次版本号',
      dataIndex: 'rvcVersionMinor',
      width: 100,
    },
    {
      title: 'RVC功能参数-修订号',
      dataIndex: 'rvcVersionPatch',
      width: 80,
    },
  ]

  return list.filter((item: any) => !item.hide)
    .map((item: any) => {
      const returnItem = { ...item };
      const { noCommonCell, dataIndex } = item;
      if (!noCommonCell) {
        returnItem.onCell = (record: any, rowIndex: number) =>
          renderDifferentTableCell(record, rowIndex, dataIndex, allData);
      }
      return returnItem;
    });
};
